import Vue from 'vue'
import IdleVue from 'idle-vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router/index'
import store from './store' 
import jslinq from 'js-linq'
import VueClipboard from 'vue-clipboard2'



Object.defineProperty(Vue.prototype,'$linq',{value:jslinq})
Vue.config.productionTip = false

const eventsHub = new Vue();

Vue.use(IdleVue,{eventEmitter:eventsHub, idleTime:1200000,store});
Vue.use(VueClipboard);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
